export const contact = {
	telephone: "0116 218 5718",
	email: "help@health-companion.me",
};
